"use strict";
Object.defineProperty(exports, "__esModule", {
  value: true
});
var updateHash = function updateHash2(hash, historyUpdate) {
  var hashVal = hash.indexOf("#") === 0 ? hash.substring(1) : hash;
  var hashToUpdate = hashVal ? "#" + hashVal : "";
  var curLoc = window && window.location;
  var urlToPush = hashToUpdate ? curLoc.pathname + curLoc.search + hashToUpdate : curLoc.pathname + curLoc.search;
  historyUpdate ? history.pushState(history.state, "", urlToPush) : history.replaceState(history.state, "", urlToPush);
};
var getHash = function getHash2() {
  return window.location.hash.replace(/^#/, "");
};
var filterElementInContainer = function filterElementInContainer2(container) {
  return function(element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};
var isPositioned = function isPositioned2(element) {
  return getComputedStyle(element).position !== "static";
};
var getElementOffsetInfoUntil = function getElementOffsetInfoUntil2(element, predicate) {
  var offsetTop = element.offsetTop;
  var currentOffsetParent = element.offsetParent;
  while (currentOffsetParent && !predicate(currentOffsetParent)) {
    offsetTop += currentOffsetParent.offsetTop;
    currentOffsetParent = currentOffsetParent.offsetParent;
  }
  return { offsetTop, offsetParent: currentOffsetParent };
};
var scrollOffset = function scrollOffset2(c, t, horizontal) {
  if (horizontal) {
    return c === document ? t.getBoundingClientRect().left + (window.scrollX || window.pageXOffset) : getComputedStyle(c).position !== "static" ? t.offsetLeft : t.offsetLeft - c.offsetLeft;
  } else {
    if (c === document) {
      return t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
    }
    if (isPositioned(c)) {
      if (t.offsetParent !== c) {
        var isContainerElementOrDocument = function isContainerElementOrDocument2(e) {
          return e === c || e === document;
        };
        var _getElementOffsetInfo = getElementOffsetInfoUntil(t, isContainerElementOrDocument), offsetTop = _getElementOffsetInfo.offsetTop, offsetParent = _getElementOffsetInfo.offsetParent;
        if (offsetParent !== c) {
          throw new Error("Seems containerElement is not an ancestor of the Element");
        }
        return offsetTop;
      }
      return t.offsetTop;
    }
    if (t.offsetParent === c.offsetParent) {
      return t.offsetTop - c.offsetTop;
    }
    var isDocument = function isDocument2(e) {
      return e === document;
    };
    return getElementOffsetInfoUntil(t, isDocument).offsetTop - getElementOffsetInfoUntil(c, isDocument).offsetTop;
  }
};
exports.default = {
  updateHash,
  getHash,
  filterElementInContainer,
  scrollOffset
};
